import { DependenciesInjection } from "app/di/DependencyInjection";
import { MobiSimRegistrationImpl } from "features/mobiSimRegistration/data/MobiSimRegistrationImpl";
import { IMobiSimRegistrationRepository } from "features/mobiSimRegistration/domain/repositories/IMobiSimRegistrationRepository";
import { MobiSimRegistrationUseCase } from "features/mobiSimRegistration/domain/useCases/MobiSimRegistrationUseCase";
import { MobiSimRegistrationViewModel } from "features/mobiSimRegistration/presentation/viewModel/MobiSimRegistrationViewModel";
import { MobiSimRegistrationToken } from "features/mobiSimRegistration/di/MobiSimRegistrationToken";

export class MobiSimRegistrationInjection {
  static initInjections(): void {
    DependenciesInjection.register<IMobiSimRegistrationRepository>(
      MobiSimRegistrationToken.IMobiSimRegistrationRepository,
      MobiSimRegistrationImpl,
      "otherRepo",
    );
    DependenciesInjection.register<MobiSimRegistrationUseCase>(
      MobiSimRegistrationToken.MobiSimRegistrationUseCase,
      MobiSimRegistrationUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<MobiSimRegistrationViewModel>(
      MobiSimRegistrationToken.MobiSimRegistrationViewModel,
      MobiSimRegistrationViewModel,
      "viewModel",
    );
  }

  static getMobiSimRegistrationRepo(): IMobiSimRegistrationRepository {
    return DependenciesInjection.getRepo<IMobiSimRegistrationRepository>(
      MobiSimRegistrationToken.IMobiSimRegistrationRepository,
    );
  }

  static getMobiSimRegistrationUseCase(): MobiSimRegistrationUseCase {
    return DependenciesInjection.getRepo<MobiSimRegistrationUseCase>(
      MobiSimRegistrationToken.MobiSimRegistrationUseCase,
    );
  }
}
